import * as Yup from "yup";
import React, { Dispatch, SetStateAction, useCallback, useState } from "react";
import { Formik } from "formik";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";

import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import api from "services/api";
import theme from "styles/theme";
import { UserInfo } from "pages/MeusDados";
import { cellPhoneNumberRegex } from "utils/regex";

import { Container, FormContainer } from "./styles";
import {
  ContainerButtons,
  Messenger,
  ModalHeader,
  ModalStyle,
  Title,
} from "../styles";

type EditPhoneProps = {
  openModal: boolean;
  modalFunction: Dispatch<SetStateAction<boolean>>;
  userInfo: UserInfo;
  setPhoneAwait: Dispatch<SetStateAction<UserInfo>>;
  setOpenTokenPhoneModal: Dispatch<SetStateAction<boolean>>;
};

const EditPhone = ({
  openModal,
  modalFunction,
  userInfo,
  setPhoneAwait,
  setOpenTokenPhoneModal,
}: EditPhoneProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>();

  const validationSchema = (): any =>
    Yup.object().shape({
      phoneNumber: Yup.string()
        .required("É necessário digitar seu número de celular")
        .test("Telefone", "Número de telefone inválido", (value) => {
          if (value) {
            const newValue = value.replace(/[^\d]/g, "");
            return !!newValue.match(cellPhoneNumberRegex);
          }
          return null;
        }),
    });

  const requestPatchCustomers = useCallback(
    async (phoneDdd, phoneNumber) => {
      try {
        setLoading(true);
        const headers = {
          access_token: localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          ),
        };
        const { unitId } = JSON.parse(
          localStorage.getItem("@UltragazEmpresarial:unitData")
        );
        const body = {
          phoneDdd,
          phoneNumber,
          unitId,
        };
        await api.patch(`industrial/customer/v1/customers/me`, body, {
          headers,
        });
        setLoading(false);
        modalFunction(false);
        setOpenTokenPhoneModal(true);
      } catch (err) {
        setLoading(false);
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    },
    [api, setLoading, modalFunction, setOpenTokenPhoneModal]
  );

  const handleSubmit = useCallback(
    ({ phoneNumber }) => {
      if (!loading) {
        if (
          phoneNumber.replace(/[^\d]/g, "") !==
          userInfo.phoneDdd + userInfo.phoneNumber
        ) {
          setPhoneAwait(phoneNumber);
          const newphoneNumber = phoneNumber.replace(/[^\d]/g, "");
          const ddd = newphoneNumber.slice(0, 2);
          const phone = newphoneNumber.slice(2);
          requestPatchCustomers(ddd, phone);
        }
      }
    },
    [requestPatchCustomers, setPhoneAwait, userInfo, loading]
  );

  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Editar dados</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Title>Telefone de contato</Title>
        <Formik
          initialValues={{
            phoneNumber: userInfo
              ? userInfo.phoneDdd + userInfo.phoneNumber || ""
              : "",
          }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <FormContainer>
              <TextField
                label="Celular *"
                name="phoneNumber"
                mask="(99) 99999-9999"
                inputMode="numeric"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                // @ts-ignore
                errorCondition={errors.phoneNumber && touched.phoneNumber}
                // @ts-ignore
                errorMessage={errors.phoneNumber}
              />
              <Messenger>Será enviado um token para validação</Messenger>
              <ContainerButtons>
                <OutlinedButton
                  color={theme.colors.purple}
                  onClick={() => modalFunction(false)}
                >
                  Cancelar
                </OutlinedButton>
                <ContainedButton type="submit" loading={loading}>
                  Atualizar
                </ContainedButton>
              </ContainerButtons>
            </FormContainer>
          )}
        />
      </Container>
    </ModalStyle>
  );
};

export default EditPhone;
